import React, { Component } from "react";
import Menu from "./includes/Menu";
import { Grid } from "../../../node_modules/@material-ui/core";

const lang = "";

class Career extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  componentDidMount() {
    document.title = this.getLangText({
      tc: "招聘人才",
      sc: "招聘人才",
      en: "Careers"
    });
  }

  getLangText(langJson) {
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  render() {
    return CareerJSX(this);
  }
}

const CareerJSX = ctx => (
  <div className={ctx.lang === "en" ? "en" : ""}>
    <Menu lang={ctx.lang} />

    <div className="main-content-container">
      <div className="main-content-inner-wrapper career">
        <Grid container spacing={0}>
          <Grid item id="page-title">
            <span>
              {ctx.getLangText({
                tc: "招聘人才",
                sc: "招聘人才",
                en: "Careers"
              })}
            </span>
          </Grid>
        </Grid>

        <div style={{ clear: "both" }} />

        <Grid item style={{ width: "100%", marginBottom: "30px" }}>
          <hr />
        </Grid>

        <div className="career-container">
          <Grid container spacing={0} id="grid-section">
            <Grid item className="sub-title theme-color">
              <span>
                {ctx.getLangText({
                  tc: "加入我們專業團隊",
                  sc: "加入我们专业团队",
                  en: "Join our professional team"
                })}
              </span>
            </Grid>
          </Grid>

          <Grid container spacing={0} className="content-container">
            <Grid item>
              <p>
                {ctx.getLangText({
                  tc:
                    "FxHB Group Company Limited是一家IT咨詢公司，發展穩健、專業可靠，多年來致力為客戶提供最優質的服務。",
                  sc:
                    "FxHB Group Company Limited是一家IT咨询公司，发展稳健、专业可靠，多年来致力为客户提供最优质的服务。",
                  en: `FxHB Group Company Limited is an IT consulting company with a stable and solid development.
                  Over the years, we strive to provide quality services for our clients with our trusted professionalism.`
                })}
              </p>
              <Grid
                container
                spacing={0}
                justify="center"
                style={{ lineHeight: "32px" }}
              >
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <p>
                    {ctx.getLangText({
                      tc:
                        "如果您有興趣加入我們的團隊，請將您的簡歷發送給我們：",
                      sc:
                        "如果您有兴趣加入我们的团队，请将您的简历发送给我们：",
                      en: `The following positions are currently available and we would like to invite you to send us your CV if you are interested in joining our team:`
                    })}
                  </p>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <a
                    href="mailto:hr@fxhbgroup.com"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="theme-color">hr@fxhbgroup.com</span>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  </div>
);

export default Career;



// WEBPACK FOOTER //
// ./src/components/pages/Career.js